<template>
  <div class="box">
    <b-loading
      v-if="isLoading"
      :is-full-page="false"
      :active="isLoading"
      :can-cancel="false"
    ></b-loading>

    <h2 class="has-text-weight-bold">
      Editar Integrantes
    </h2>
    <br />

    <b-field
      :label="oe.numberOfStudents ? 'Número de integrantes da graduação*' : ''"
      label-position="on-border"
    >
      <b-input
        v-model="oe.numberOfStudents"
        type="number"
        placeholder="Número de integrantes da graduação*"
        expanded
      ></b-input>
    </b-field>

    <br />
    <p>Informe a distribuição dos integrantes da OE por curso*</p>
    <br />

    <div
      v-for="(entry, index) in oe.membersPerCourse"
      :key="`course-${index}`"
      style="margin-bottom: 1rem"
    >
      <course-and-quantity
        :entry="entry"
        :index="index"
        @add-entry="addCourseEntry"
        @remove-entry="removeCourseEntry"
      />
    </div>

    <br />
    <p>Diversidade & Inclusão - Sua OE já está avançando nesta direção?</p>
    <br />

    <div class="columns">
      <div class="column">
        <b-field
          :label="oe.numberOfWomenStudents !== '' ? 'Número de mulheres' : ''"
          label-position="on-border"
        >
          <b-input
            v-model="oe.numberOfWomenStudents"
            type="number"
            placeholder="Número de mulheres"
            expanded
          ></b-input>
        </b-field>
      </div>
      <div class="column">
        <b-field
          :label="
            oe.numberOfBlackStudents ? 'Número de Negros (pretos + pardos)' : ''
          "
          label-position="on-border"
        >
          <b-input
            v-model="oe.numberOfBlackStudents"
            type="number"
            placeholder="Número de Negros (pretos + pardos)"
            expanded
          ></b-input>
        </b-field>
      </div>
    </div>

    <div class="columns">
      <div class="column">
        <b-field
          v-if="oe.LGBTStudents"
          :label="oe.LGBTStudents ? 'Integrantes LGBTQIA+' : ''"
          label-position="on-border"
        >
          <b-input
            v-if="oe.LGBTStudents"
            v-model="oe.LGBTStudents"
            placeholder="Integrantes LGBTQIA+"
            maxlength="1500"
            type="number"
            rows="3"
            style="margin-top: 0.5rem;"
          ></b-input>
          <b-input
            v-else
            v-model="oe.numberOfLGBTStudents"
            placeholder="Integrantes LGBTQIA+"
            maxlength="1500"
            type="number"
            rows="3"
            style="margin-top: 0.5rem;"
          ></b-input>
        </b-field>
        <b-field
          v-else
          :label="oe.numberOfLGBTStudents ? 'Integrantes LGBTQIA+' : ''"
          label-position="on-border"
        >
          <b-input
            v-if="oe.LGBTStudents"
            v-model="oe.LGBTStudents"
            placeholder="Integrantes LGBTQIA+"
            maxlength="1500"
            type="number"
            rows="3"
            style="margin-top: 0.5rem;"
          ></b-input>
          <b-input
            v-else
            v-model="oe.numberOfLGBTStudents"
            placeholder="Integrantes LGBTQIA+"
            maxlength="1500"
            type="number"
            rows="3"
            style="margin-top: 0.5rem;"
          ></b-input>
        </b-field>
      </div>

      <div class="column">
        <b-field
          :label="oe.otherMinorities ? 'Minorias (detalhe por minoria)' : ''"
          label-position="on-border"
        >
          <b-input
            v-model="oe.otherMinorities"
            placeholder="Detalhe por minoria. Ex: Indígenas (3), Imigrantes (2), Idosos (1), Moradores de vilas / favelas (1)"
            maxlength="1500"
            type="textarea"
            rows="3"
            style="margin-top: 0.5rem;"
          ></b-input>
        </b-field>
      </div>
    </div>
    <Pendencies :pendencies="pendencies" />
    <div>
      <button
        class="button is-primary is-rounded"
        style="margin-left: auto; display: block;"
        @click="updateOrganization"
        :disabled="pendencies.length > 0"
      >
        Salvar
      </button>
    </div>
  </div>
</template>

<script>
import { commom } from "../../../mixins/commom";
import Pendencies from "../../commom/Pendencies.vue";
import courseAndQuantity from "../CourseAndQuantity";

export default {
  name: "FormTeamMembers",

  props: ["oe"],

  mixins: [commom],

  components: {
    courseAndQuantity,
    Pendencies
  },

  data() {
    return {
      isLoading: false
    };
  },

  methods: {
    addCourseEntry() {
      this.oe.membersPerCourse.push({
        course: "",
        quantity: ""
      });
    },

    removeCourseEntry(index) {
      if (this.oe.membersPerCourse.length > 1) {
        this.oe.membersPerCourse.splice(index, 1);
      }
    },

    updateOrganization() {
      this.isLoading = true;

      this.$store
        .dispatch("updateOrganization", {
          oe: this.oe
        })
        .then(res => {
          if (res.data.result === "ok") {
            this.showOrganizationEmailInput = false;
            this.$buefy.dialog.alert({
              title: "Sucesso!",
              message:
                "As informações dos integrantes da OE foram atualizadas 😉",
              type: "is-success",
              hasIcon: true,
              icon: "check",
              iconPack: "fa"
            });
            if (this.oe.fanpage) {
              this.oeHasFanpage = true;
              if (this.oe.fanpage.indexOf("https") === -1) {
                this.oe.fanpage = "https://www.facebook.com/" + this.oe.fanpage;
              }
            }
            if (this.oe.insta) {
              this.oeHasInsta = true;
              if (this.oe.insta.indexOf("https") === -1) {
                this.oe.insta = "https://www.instagram.com/" + this.oe.insta;
              }
            }
            if (this.oe.linkedin) {
              this.oeHasLinkedin = true;
              if (this.oe.linkedin.indexOf("https") === -1) {
                this.oe.linkedin =
                  "https://www.linkedin.com/company/" + this.oe.linkedin;
              }
            }
          } else {
            this.alertError(res.data);
          }
        })
        .catch(() => {
          this.alertError({ message: "UNEXPECTED_ERROR" });
        })
        .finally(() => {
          this.isLoading = false;
        });
    }
  },

  computed: {
    pendencies() {
      const pendencies = [];

      if (this.oe.numberOfStudents == "" || this.oe.numberOfStudents == 0) {
        pendencies.push("Número de integrantes da graduação");
      }

      for (let i = 0; i < this.oe.membersPerCourse.length; i++) {
        if (this.oe.membersPerCourse[i].course == "") {
          pendencies.push("Nome do " + (i + 1) + "º curso");
        }

        if (
          this.oe.membersPerCourse[i].quantity == "" ||
          this.oe.membersPerCourse[i].quantity == 0
        ) {
          pendencies.push("Quantidade de estudantes do " + (i + 1) + "º curso");
        }
      }

      if (this.oe.numberOfWomenStudents === "") {
        pendencies.push("Número de mulheres (se não tiver nenhuma, coloque 0)");
      }

      if (this.oe.numberOfBlackStudents === "") {
        pendencies.push(
          "Número de pessoas pretas (se não tiver nenhuma, coloque 0)"
        );
      }

      if (this.oe.LGBTStudents === "") {
        pendencies.push(
          "Número de integrantes LGBTQIA+ (se não tiver nenhum, coloque 0)"
        );
      }

      return pendencies;
    }
  }
};
</script>

<style scoped>
.box {
  padding: 2rem 3rem;
  max-width: 800px !important;
  margin: auto;
}
@media (max-width: 400px) {
  .box {
    padding: 0.5rem !important;
  }
}
</style>
